import React from 'react'
import { cn } from '@/lib/utils'

/** The white card every Settings section sits in: a title, a line under it, an action */
export const SettingsCard: React.FC<{
  title: string
  subtitle?: string
  action?: React.ReactNode
  className?: string
  children: React.ReactNode
}> = ({ title, subtitle, action, className, children }) => (
  <section className={cn('rounded-2xl border border-border bg-card p-5 shadow-sm', className)}>
    <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h2 className="font-bold text-foreground">{title}</h2>
        {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
      </div>
      {action}
    </div>
    {children}
  </section>
)

export default SettingsCard
